// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zQe5q","controls":"styles_controls__MMsA4","charLimit":"styles_charLimit__1H2aU","input":"styles_input__25vb0","send":"styles_send__1GgIQ"};